var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.131994 12.4402C0.280787 12.6642 0.531175 12.7994 0.799963 12.7994H12.7994C13.1194 12.7994 13.409 12.609 13.5346 12.3146L15.9345 6.71489C15.987 6.59324 16.0085 6.46042 15.997 6.3284C15.9854 6.19638 15.9411 6.06932 15.8682 5.95867C15.7952 5.84803 15.6959 5.75728 15.5791 5.69462C15.4624 5.63196 15.3318 5.59935 15.1993 5.59974H14.3993V3.19985C14.3993 2.31749 13.6818 1.59993 12.7994 1.59993H7.47565L5.43095 0H1.59993C0.717567 0 0 0.717567 0 1.59993V11.9994H0.00559971C0.00381669 12.1556 0.0477534 12.3088 0.131994 12.4402ZM12.7994 3.19985V5.59974H3.19985C2.87987 5.59974 2.59028 5.79013 2.46469 6.08452L1.59993 8.10282V3.19985H12.7994Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.92a0fc42.svg";
export { ForwardRef as ReactComponent };